import { Link } from "react-router";

import { finalCtaFallback, type CTAOption } from "@/data/cta-options";

import { ArrowRight } from "./Button";

export type { CTAOption };
export const finalCtaOptions = finalCtaFallback;

/** Three-way closing CTA, one card per audience, never a single generic button. */
export function CTAGroup({
  options = finalCtaOptions,
  tone = "dark",
}: {
  options?: CTAOption[];
  tone?: "dark" | "light";
}) {
  const dark = tone === "dark";

  return (
    <ul className="grid gap-5 md:grid-cols-3">
      {options.map((option) => (
        <li key={option.href + option.title}>
          <div
            className={`group relative flex h-full flex-col rounded-[16px] border p-6 transition-[transform,border-color] duration-300 hover:-translate-y-1 md:p-7 ${
              dark
                ? "border-white/20 bg-white/5 hover:border-sky"
                : "border-line bg-white hover:border-line-strong"
            }`}
          >
            <h3
              className={dark ? "text-white" : ""}
              style={{ fontSize: "var(--step-h4)" }}
            >
              {option.title}
            </h3>
            <p className={`mt-3 text-[0.9375rem] ${dark ? "text-white/75" : "text-muted"}`}>
              {option.description}
            </p>
            <Link
              to={option.href}
              className={`mt-auto inline-flex min-h-11 items-center gap-2 pt-6 text-[0.9375rem] font-semibold ${
                dark ? "text-sky" : "text-navy"
              }`}
            >
              <span className="after:absolute after:inset-0 after:content-['']">
                {option.action}
              </span>
              <ArrowRight className="transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
          </div>
        </li>
      ))}
    </ul>
  );
}
